import React from 'react';
import Page from "../../containers/Page/Page";
import { Button, Box, Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Grid } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import SearchField from "../../components/SearchField";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import moment from 'moment';
import { Helpers } from '../../utils/Helpers';
import { usePermissions } from '../../hooks/permissions';

interface IData {
    data: {
        id: string;
        codigo_sap: string;
        nome: string;
        tipo_material: string;
        ativa: boolean;
        created_at: string;
        modelo: {
            nome: string;
        };
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Bombas() {

    const history = useHistory();
    const permissions = usePermissions();
    const query = new URLSearchParams(history.location.search);

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar bombas.
     * @param page 
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/bombas?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Bombas
                </Typography>
                {permissions.has('bomba.show') &&
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => history.push('/bombas/create')}>
                        Nova Bomba
                    </Button>
                }
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                            onClick={() => handleFetch(1)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Código SAP</TableCell>
                                        <TableCell>Bomba</TableCell>
                                        <TableCell>Material</TableCell>
                                        <TableCell>Ativo</TableCell>
                                        <TableCell>Data Criação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((bomba) => (
                                        <TableRow
                                            key={bomba.id}
                                            hover={true}
                                            onClick={() => history.push(`/bombas/${bomba.id}`)}
                                        >
                                            <TableCell>{bomba.id}</TableCell>
                                            <TableCell>{bomba.codigo_sap}</TableCell>
                                            <TableCell>{bomba.nome}</TableCell>
                                            <TableCell>{bomba.tipo_material}</TableCell>
                                            <TableCell>{bomba.ativa ? 'Sim' : 'Não'}</TableCell>
                                            <TableCell>{moment(bomba.created_at).format('DD/MM/YYYY')}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Bombas;